

const url = 'https://ehome.eelian.com.cn' // 正式环境
// const url = 'https://ehome.fooktech.cn'

export default url